/**
 * Super-Admin одноязычный (RU). Используется Eroloft'ом, не tenant'ами.
 * Если позже захочется EN/KZ — добавить файлы и расширить useT.
 */
export const ru = {
  brand: {
    title: "Orda OS Platform",
    subtitle: "Платформенная панель Eroloft",
  },
  login: {
    title: "Вход в Platform",
    subtitle: "Введите email — пришлём magic-link",
    emailLabel: "Email",
    emailPlaceholder: "your.email@example.com",
    submit: "Отправить ссылку",
    submitting: "Отправляем…",
    sent: "Если адрес авторизован, ссылка отправлена на",
    sentHint: "Проверь почту — переход обратно произойдёт автоматически. Письмо приходит только авторизованным адресам.",
    error: "Не получилось отправить. Попробуй ещё раз.",
  },
  gate: {
    denied: "Доступ запрещён",
    deniedHint: "Этот email не в super-admin allowlist. Если ты Eroloft — войди под правильным email.",
    signOut: "Выйти",
    loading: "Загрузка…",
  },
  nav: {
    tenants: "Tenants",
    analytics: "Аналитика",
    settings: "Настройки",
    signOut: "Выйти",
  },
  tenants: {
    title: "Тенанты",
    subtitle: "Все кафе на платформе",
    create: "Создать tenant",
    empty: "Пока нет ни одного tenant'а. Создай первый.",
    columns: {
      slug: "Slug",
      name: "Название",
      created: "Создан",
      tables: "Столов",
      staff: "Сотрудников",
      lastActivity: "Последняя активность",
      actions: "Действия",
    },
    actions: {
      open: "Открыть",
      visit: "Посетить",
    },
    loadError: "Ошибка загрузки tenants",
  },
  createTenant: {
    title: "Новый tenant",
    slugLabel: "Slug (для URL)",
    slugHint: "латиница, цифры, дефис. Пример: kausar → kausar.e-menu.bar",
    nameRuLabel: "Название (RU)",
    nameKzLabel: "Название (KZ)",
    nameEnLabel: "Название (EN)",
    ownerEmailLabel: "Email владельца",
    ownerNameLabel: "Имя владельца",
    submit: "Создать",
    submitting: "Создаём…",
    success: "Tenant создан",
    error: "Ошибка создания tenant'а",
    cancel: "Отмена",
    successUrl: "Дай этот URL владельцу — там он установит PIN:",
    vercelAutoAdded: "✓ Домен добавлен в Vercel автоматически. SSL выпускается ~1-5 мин.",
    vercelManual: "⚠️ Vercel API не сработал — добавь домен вручную:",
    vercelManualHint: "vercel.com/dashboard → Project cafe-osv2 → Settings → Domains → Add",
  },
  tenantDetail: {
    backToList: "← К списку",
    menuItems: "Меню",
    upload3d: "Загрузить .glb",
    has3d: "✓ Открыть 3D",
    no3d: "—",
    uploadHint: "Файл должен быть оптимизирован через scripts/repack-models-for-ar.mjs (Draco compression). Max 25MB.",
    uploadError: "Ошибка загрузки",
    uploadSuccess: "Модель загружена",
  },
  analytics: {
    title: "Аналитика платформы",
    period: "Период",
    period7d: "7 дней",
    period30d: "30 дней",
    period90d: "90 дней",
    period365d: "Год",
    columns: {
      tenant: "Tenant",
      orders: "Заказов",
      revenue: "Выручка",
      tables: "Столов",
      staff: "Активных сотрудников",
    },
    loading: "Считаем…",
    error: "Ошибка загрузки аналитики",
    total: "Итого",
  },
  common: {
    loading: "Загрузка…",
    error: "Ошибка",
    retry: "Повторить",
    close: "Закрыть",
  },
};

export type Dict = typeof ru;
